import React from "react";
import styled from "styled-components";
import { theme } from "../theme/theme";

const menuOptions = {
  color: theme.primary,
  displayMaxWidth: "1050px",
  heightLine: "2px",
  heightIcon: "18px",
  transitionTime: "0.2s",
  rotation: "45deg",
  translateY: "9px",
  translateX: 0
};

export const BurgerIcon = ({ menuOpen, onClick }) => {
  return (
    <Container role="navigation" aria-label="Main" onClick={onClick}>
      <MenuIcon className={`BurgerIcon${menuOpen ? " active" : ""}`}>
        <span className="line line-1"></span>
        <span className="line line-2"></span>
        <span className="line line-3"></span>
      </MenuIcon>
    </Container>
  );
};
const Container = styled.div`
  display: none;
  @media (max-width: ${menuOptions.displayMaxWidth}) {
    display: flex;
    width: 40px;
    height: 40px;
    align-items: center;
    justify-content: center;

    :hover {
      cursor: pointer;
    }
  }
`;

const MenuIcon = styled.button`
  width: 30px;
  height: ${menuOptions.heightIcon};
  position: relative;
  z-index: 3;
  display: none;
  @media (max-width: ${menuOptions.displayMaxWidth}) {
    display: block;
  }

  .line {
    display: block;
    background: ${menuOptions.color};
    width: 30px;
    height: ${menuOptions.heightLine};
    position: absolute;
    left: 0;
    border-radius: calc(${menuOptions.heightLine} / 2);
    transition: all ${menuOptions.transitionTime};
    -webkit-transition: all ${menuOptions.transitionTime};
    -moz-transition: all ${menuOptions.transitionTime};

    &.line-1 {
      top: 0;
    }
    &.line-2 {
      top: 50%;
    }
    &.line-3 {
      top: 100%;
    }
  }
  &.active {
    .line-1 {
      transform: translateY(${menuOptions.translateY})
        translateX(${menuOptions.translateX}) rotate(${menuOptions.rotation});
      -webkit-transform: translateY(${menuOptions.translateY})
        translateX(${menuOptions.translateX}) rotate(${menuOptions.rotation});
      -moz-transform: translateY(${menuOptions.translateY})
        translateX(${menuOptions.translateX}) rotate(${menuOptions.rotation});
    }
    .line-2 {
      opacity: 0;
    }
    .line-3 {
      transform: translateY(calc(${menuOptions.translateY} * -1))
        translateX(${menuOptions.translateX})
        rotate(calc(${menuOptions.rotation} * -1));
      -webkit-transform: translateY(calc(${menuOptions.translateY} * -1))
        translateX(${menuOptions.translateX})
        rotate(calc(${menuOptions.rotation} * -1));
      -moz-transform: translateY(calc(${menuOptions.translateY} * -1))
        translateX(${menuOptions.translateX})
        rotate(calc(${menuOptions.rotation} * -1));
    }
  }
`;
